import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = { context: { clientName: "auth-api" } } as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: { [key: string]: any };
  UnixTimestampSec: any;
};

export type AddPaymentMethodResult = {
  __typename?: "AddPaymentMethodResult";
  error?: Maybe<Scalars["String"]>;
  paymentMethod?: Maybe<RecurlyPaymentMethod>;
  success?: Maybe<Scalars["Boolean"]>;
};

export type BillingData = {
  __typename?: "BillingData";
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  isActive?: Maybe<Scalars["Boolean"]>;
  subscription?: Maybe<PaymentSubscription>;
  upcomingInvoice?: Maybe<UpcomingInvoice>;
};

export type CancelSubscriptionResponse = {
  __typename?: "CancelSubscriptionResponse";
  error?: Maybe<Scalars["String"]>;
  subscription?: Maybe<SubscriptionInfo>;
  success: Scalars["Boolean"];
};

export type Champion = {
  __typename?: "Champion";
  championId: Scalars["Int"];
};

export type FilterBuildsAndRunes = {
  __typename?: "FilterBuildsAndRunes";
  mmr?: Maybe<Scalars["String"]>;
  queueType?: Maybe<Scalars["String"]>;
  regionId?: Maybe<Scalars["String"]>;
};

export type FilterDefaults = {
  __typename?: "FilterDefaults";
  filterBuildsAndRunes?: Maybe<FilterBuildsAndRunes>;
  filterProBuilds?: Maybe<FilterProBuilds>;
  filterTierList?: Maybe<FilterTierList>;
};

export type FilterProBuilds = {
  __typename?: "FilterProBuilds";
  queueType?: Maybe<Scalars["String"]>;
  role?: Maybe<Scalars["String"]>;
  victoryOnly?: Maybe<Scalars["Boolean"]>;
};

export type FilterTierList = {
  __typename?: "FilterTierList";
  mmr?: Maybe<Scalars["String"]>;
  queueType?: Maybe<Scalars["String"]>;
  regionId?: Maybe<Scalars["String"]>;
  role?: Maybe<Scalars["String"]>;
  showAllChampions?: Maybe<Scalars["Boolean"]>;
};

export type InputSummoner = {
  iconId?: InputMaybe<Scalars["String"]>;
  iconUrl?: InputMaybe<Scalars["String"]>;
  isDefault?: InputMaybe<Scalars["Boolean"]>;
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type Invoice = {
  __typename?: "Invoice";
  brand?: Maybe<Scalars["String"]>;
  currency?: Maybe<Scalars["String"]>;
  last4?: Maybe<Scalars["String"]>;
  paid?: Maybe<Scalars["Boolean"]>;
  periodEnd?: Maybe<Scalars["UnixTimestampSec"]>;
  periodStart?: Maybe<Scalars["UnixTimestampSec"]>;
  totalPaid?: Maybe<Scalars["Int"]>;
};

export type LoginState = {
  __typename?: "LoginState";
  token: Scalars["String"];
};

export type LolSettings = {
  __typename?: "LolSettings";
  favoriteChampions?: Maybe<Array<Maybe<Champion>>>;
  favoriteSummoners?: Maybe<Array<Maybe<Summoner>>>;
  summoners?: Maybe<Array<Maybe<Summoner>>>;
};

export type OauthConnection = {
  __typename?: "OauthConnection";
  connectionUuid: Scalars["String"];
  creationTime?: Maybe<Scalars["UnixTimestampSec"]>;
  lastRefreshTime?: Maybe<Scalars["UnixTimestampSec"]>;
  metadata?: Maybe<Scalars["JSON"]>;
  providerEmail?: Maybe<Scalars["String"]>;
  providerName: Scalars["String"];
  providerUserId: Scalars["String"];
  providerUsername?: Maybe<Scalars["String"]>;
};

export type OauthLoginResult = {
  __typename?: "OauthLoginResult";
  oauthSessionToken?: Maybe<Scalars["String"]>;
  providerEmail?: Maybe<Scalars["String"]>;
  providerUsername?: Maybe<Scalars["String"]>;
  state?: Maybe<State>;
};

export type OauthLoginUrl = {
  __typename?: "OauthLoginUrl";
  url: Scalars["String"];
};

export type PaymentSubscription = {
  __typename?: "PaymentSubscription";
  cancelAtPeriodEnd?: Maybe<Scalars["Boolean"]>;
  currentPeriodEnd?: Maybe<Scalars["UnixTimestampSec"]>;
  isBraintree?: Maybe<Scalars["Boolean"]>;
  isPaypal?: Maybe<Scalars["Boolean"]>;
  status?: Maybe<Scalars["String"]>;
};

export type Premium = {
  __typename?: "Premium";
  freeTrialAvailable?: Maybe<Scalars["Boolean"]>;
  hasFailedPayment?: Maybe<Scalars["Boolean"]>;
  hasLegacyBoost?: Maybe<Scalars["Boolean"]>;
  isOnFreeTrial?: Maybe<Scalars["Boolean"]>;
  isPremium: Scalars["Boolean"];
  paymentFailureDate?: Maybe<Scalars["UnixTimestampSec"]>;
  premiumVersion?: Maybe<Scalars["String"]>;
};

export type RecurlyBillingData = {
  __typename?: "RecurlyBillingData";
  invoices?: Maybe<Array<Maybe<RecurlyInvoice>>>;
  paymentMethods?: Maybe<Array<Maybe<RecurlyPaymentMethodDetail>>>;
  subscription?: Maybe<RecurlySubscription>;
  upcomingInvoice?: Maybe<RecurlyUpcomingInvoice>;
};

export type RecurlyInvoice = {
  __typename?: "RecurlyInvoice";
  brand?: Maybe<Scalars["String"]>;
  currency?: Maybe<Scalars["String"]>;
  last4?: Maybe<Scalars["String"]>;
  paid?: Maybe<Scalars["Boolean"]>;
  periodEnd?: Maybe<Scalars["UnixTimestampSec"]>;
  periodStart?: Maybe<Scalars["UnixTimestampSec"]>;
  totalPaid?: Maybe<Scalars["Int"]>;
};

export type RecurlyPaymentMethod = {
  __typename?: "RecurlyPaymentMethod";
  cardType?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  isDefault?: Maybe<Scalars["Boolean"]>;
  lastFour?: Maybe<Scalars["String"]>;
  paypalEmail?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
};

export type RecurlyPaymentMethodDetail = {
  __typename?: "RecurlyPaymentMethodDetail";
  cardType?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  isDefault?: Maybe<Scalars["Boolean"]>;
  lastFour?: Maybe<Scalars["String"]>;
  paypalEmail?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
};

export type RecurlySubscription = {
  __typename?: "RecurlySubscription";
  cancelAtPeriodEnd?: Maybe<Scalars["Boolean"]>;
  currentPeriodEnd?: Maybe<Scalars["UnixTimestampSec"]>;
  isOnFreeTrial?: Maybe<Scalars["Boolean"]>;
  planInterval?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  trialEndsAt?: Maybe<Scalars["UnixTimestampSec"]>;
  unitAmount?: Maybe<Scalars["Int"]>;
};

export type RecurlyUpcomingInvoice = {
  __typename?: "RecurlyUpcomingInvoice";
  chargeAmount?: Maybe<Scalars["Int"]>;
  error?: Maybe<Scalars["String"]>;
  nextPaymentAttempt?: Maybe<Scalars["UnixTimestampSec"]>;
  subtotal?: Maybe<Scalars["Int"]>;
};

export type RootMutationType = {
  __typename?: "RootMutationType";
  addRecurlyPaymentMethod?: Maybe<AddPaymentMethodResult>;
  cancelRecurlySubscription?: Maybe<CancelSubscriptionResponse>;
  completeOauthLink?: Maybe<OauthConnection>;
  completeOauthLogin?: Maybe<OauthLoginResult>;
  createAccountWithOauth?: Maybe<State>;
  deleteRecurlyPaymentMethod?: Maybe<StatusWithError>;
  deleteSocialLink?: Maybe<Status>;
  deleteUser?: Maybe<Status>;
  linkOauthToExistingAccount?: Maybe<State>;
  reactivateRecurlySubscription?: Maybe<SubscriptionStatus>;
  register?: Maybe<LoginState>;
  setDefaultRecurlyPaymentMethod?: Maybe<StatusWithError>;
  unlinkOauthConnection?: Maybe<Status>;
  updateEmail?: Maybe<LoginState>;
  updatePassword?: Maybe<Status>;
  updateRecurlyPaymentMethod?: Maybe<AddPaymentMethodResult>;
  updateSocialLink?: Maybe<SocialLink>;
  verify?: Maybe<Status>;
};

export type RootMutationTypeAddRecurlyPaymentMethodArgs = {
  recurlyToken: Scalars["String"];
};

export type RootMutationTypeCompleteOauthLinkArgs = {
  oauthCallbackToken: Scalars["String"];
  providerName: Scalars["String"];
};

export type RootMutationTypeCompleteOauthLoginArgs = {
  oauthCallbackToken: Scalars["String"];
  providerName: Scalars["String"];
};

export type RootMutationTypeCreateAccountWithOauthArgs = {
  agreementSigned: Scalars["Boolean"];
  email: Scalars["String"];
  marketingOptOut: Scalars["Boolean"];
  oauthSessionToken: Scalars["String"];
  password: Scalars["String"];
};

export type RootMutationTypeDeleteSocialLinkArgs = {
  platform: Scalars["String"];
};

export type RootMutationTypeDeleteUserArgs = {
  email: Scalars["String"];
  password: Scalars["String"];
};

export type RootMutationTypeLinkOauthToExistingAccountArgs = {
  email: Scalars["String"];
  oauthSessionToken: Scalars["String"];
  password: Scalars["String"];
};

export type RootMutationTypeReactivateRecurlySubscriptionArgs = {
  recaptchaToken: Scalars["String"];
  recaptchaVersion: Scalars["String"];
  recurlyToken: Scalars["String"];
};

export type RootMutationTypeRegisterArgs = {
  agreementSigned: Scalars["Boolean"];
  email: Scalars["String"];
  marketingOptOut: Scalars["Boolean"];
  password: Scalars["String"];
  primarySummoner?: InputMaybe<InputSummoner>;
};

export type RootMutationTypeSetDefaultRecurlyPaymentMethodArgs = {
  recurlyToken: Scalars["String"];
};

export type RootMutationTypeUnlinkOauthConnectionArgs = {
  connectionUuid: Scalars["String"];
};

export type RootMutationTypeUpdateEmailArgs = {
  newEmail: Scalars["String"];
  oldEmail: Scalars["String"];
  password: Scalars["String"];
};

export type RootMutationTypeUpdatePasswordArgs = {
  newPassword: Scalars["String"];
  password?: InputMaybe<Scalars["String"]>;
  passwordResetHash?: InputMaybe<Scalars["String"]>;
};

export type RootMutationTypeUpdateRecurlyPaymentMethodArgs = {
  recurlyToken: Scalars["String"];
};

export type RootMutationTypeUpdateSocialLinkArgs = {
  platform: Scalars["String"];
  username: Scalars["String"];
};

export type RootMutationTypeVerifyArgs = {
  verificationCode: Scalars["String"];
};

export type RootQueryType = {
  __typename?: "RootQueryType";
  forgotPassword?: Maybe<Status>;
  getBillingData?: Maybe<BillingData>;
  getOauthConnections?: Maybe<Array<Maybe<OauthConnection>>>;
  getRecurlyBillingData?: Maybe<RecurlyBillingData>;
  getSocialLinks?: Maybe<Array<Maybe<SocialLink>>>;
  getSubscriptionStatus?: Maybe<BillingData>;
  initiateOauthLink?: Maybe<OauthLoginUrl>;
  initiateOauthLogin?: Maybe<OauthLoginUrl>;
  isLoggedIn?: Maybe<Scalars["String"]>;
  login?: Maybe<State>;
  logout?: Maybe<Status>;
  reverifyEmail?: Maybe<Status>;
};

export type RootQueryTypeForgotPasswordArgs = {
  debug?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
};

export type RootQueryTypeInitiateOauthLinkArgs = {
  mode?: InputMaybe<Scalars["String"]>;
  providerName: Scalars["String"];
  redirectLocal?: InputMaybe<Scalars["Boolean"]>;
};

export type RootQueryTypeInitiateOauthLoginArgs = {
  mode?: InputMaybe<Scalars["String"]>;
  providerName: Scalars["String"];
  redirectLocal?: InputMaybe<Scalars["Boolean"]>;
};

export type RootQueryTypeIsLoggedInArgs = {
  userName: Scalars["String"];
};

export type RootQueryTypeLoginArgs = {
  email: Scalars["String"];
  password: Scalars["String"];
};

export type RootQueryTypeReverifyEmailArgs = {
  debug?: InputMaybe<Scalars["String"]>;
};

export type SocialLink = {
  __typename?: "SocialLink";
  creationTime?: Maybe<Scalars["UnixTimestampSec"]>;
  platform: Scalars["String"];
  socialLinkUuid: Scalars["String"];
  updatedTime?: Maybe<Scalars["UnixTimestampSec"]>;
  url: Scalars["String"];
  username: Scalars["String"];
};

export type State = {
  __typename?: "State";
  email: Scalars["String"];
  filterDefaults?: Maybe<FilterDefaults>;
  firstName: Scalars["String"];
  googleAnalyticsId?: Maybe<Scalars["String"]>;
  isVerified: Scalars["Boolean"];
  lastName: Scalars["String"];
  loginState?: Maybe<LoginState>;
  lolSettings: LolSettings;
  oauthConnections?: Maybe<Array<Maybe<OauthConnection>>>;
  premium: Premium;
  socialLinks?: Maybe<Array<Maybe<SocialLink>>>;
};

export type Status = {
  __typename?: "Status";
  success?: Maybe<Scalars["Boolean"]>;
};

export type StatusWithError = {
  __typename?: "StatusWithError";
  error?: Maybe<Scalars["String"]>;
  success?: Maybe<Scalars["Boolean"]>;
};

export type SubscriptionInfo = {
  __typename?: "SubscriptionInfo";
  cancelAtPeriodEnd?: Maybe<Scalars["Boolean"]>;
  currentPeriodEnd?: Maybe<Scalars["UnixTimestampSec"]>;
  status?: Maybe<Scalars["String"]>;
};

export type SubscriptionStatus = {
  __typename?: "SubscriptionStatus";
  currentPeriodEndsAt?: Maybe<Scalars["UnixTimestampSec"]>;
  error?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  isTrialSubscription: Scalars["Boolean"];
  status?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
  trialEndsAt?: Maybe<Scalars["UnixTimestampSec"]>;
};

export type Summoner = {
  __typename?: "Summoner";
  iconId?: Maybe<Scalars["String"]>;
  iconUrl?: Maybe<Scalars["String"]>;
  isDefault?: Maybe<Scalars["Boolean"]>;
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  verified?: Maybe<Scalars["Boolean"]>;
};

export type UpcomingInvoice = {
  __typename?: "UpcomingInvoice";
  chargeAmount?: Maybe<Scalars["Int"]>;
  error?: Maybe<Scalars["String"]>;
  nextPaymentAttempt?: Maybe<Scalars["Int"]>;
  subtotal?: Maybe<Scalars["Int"]>;
};

export type FragLoginStateFragment = {
  __typename?: "State";
  firstName: string;
  lastName: string;
  email: string;
  isVerified: boolean;
  googleAnalyticsId?: string | null;
  loginState?: { __typename?: "LoginState"; token: string } | null;
  lolSettings: {
    __typename?: "LolSettings";
    summoners?: Array<{
      __typename?: "Summoner";
      isDefault?: boolean | null;
      regionId: string;
      riotUserName: string;
      riotTagLine: string;
      verified?: boolean | null;
      iconUrl?: string | null;
      iconId?: string | null;
    } | null> | null;
    favoriteChampions?: Array<{ __typename?: "Champion"; championId: number } | null> | null;
    favoriteSummoners?: Array<{
      __typename?: "Summoner";
      regionId: string;
      riotUserName: string;
      riotTagLine: string;
      iconUrl?: string | null;
      iconId?: string | null;
    } | null> | null;
  };
  filterDefaults?: {
    __typename?: "FilterDefaults";
    filterTierList?: {
      __typename?: "FilterTierList";
      mmr?: string | null;
      queueType?: string | null;
      regionId?: string | null;
      role?: string | null;
      showAllChampions?: boolean | null;
    } | null;
    filterBuildsAndRunes?: {
      __typename?: "FilterBuildsAndRunes";
      mmr?: string | null;
      queueType?: string | null;
      regionId?: string | null;
    } | null;
  } | null;
  oauthConnections?: Array<{
    __typename?: "OauthConnection";
    connectionUuid: string;
    lastRefreshTime?: any | null;
    metadata?: { [key: string]: any } | null;
    providerName: string;
    providerUserId: string;
    providerUsername?: string | null;
    providerEmail?: string | null;
    creationTime?: any | null;
  } | null> | null;
  premium: {
    __typename?: "Premium";
    isPremium: boolean;
    premiumVersion?: string | null;
    hasFailedPayment?: boolean | null;
    paymentFailureDate?: any | null;
  };
};

export type LoginQueryVariables = Exact<{
  email: Scalars["String"];
  password: Scalars["String"];
}>;

export type LoginQuery = {
  __typename?: "RootQueryType";
  login?: {
    __typename?: "State";
    firstName: string;
    lastName: string;
    email: string;
    isVerified: boolean;
    googleAnalyticsId?: string | null;
    loginState?: { __typename?: "LoginState"; token: string } | null;
    lolSettings: {
      __typename?: "LolSettings";
      summoners?: Array<{
        __typename?: "Summoner";
        isDefault?: boolean | null;
        regionId: string;
        riotUserName: string;
        riotTagLine: string;
        verified?: boolean | null;
        iconUrl?: string | null;
        iconId?: string | null;
      } | null> | null;
      favoriteChampions?: Array<{ __typename?: "Champion"; championId: number } | null> | null;
      favoriteSummoners?: Array<{
        __typename?: "Summoner";
        regionId: string;
        riotUserName: string;
        riotTagLine: string;
        iconUrl?: string | null;
        iconId?: string | null;
      } | null> | null;
    };
    filterDefaults?: {
      __typename?: "FilterDefaults";
      filterTierList?: {
        __typename?: "FilterTierList";
        mmr?: string | null;
        queueType?: string | null;
        regionId?: string | null;
        role?: string | null;
        showAllChampions?: boolean | null;
      } | null;
      filterBuildsAndRunes?: {
        __typename?: "FilterBuildsAndRunes";
        mmr?: string | null;
        queueType?: string | null;
        regionId?: string | null;
      } | null;
    } | null;
    oauthConnections?: Array<{
      __typename?: "OauthConnection";
      connectionUuid: string;
      lastRefreshTime?: any | null;
      metadata?: { [key: string]: any } | null;
      providerName: string;
      providerUserId: string;
      providerUsername?: string | null;
      providerEmail?: string | null;
      creationTime?: any | null;
    } | null> | null;
    premium: {
      __typename?: "Premium";
      isPremium: boolean;
      premiumVersion?: string | null;
      hasFailedPayment?: boolean | null;
      paymentFailureDate?: any | null;
    };
  } | null;
};

export type LogoutQueryVariables = Exact<{ [key: string]: never }>;

export type LogoutQuery = { __typename?: "RootQueryType"; logout?: { __typename?: "Status"; success?: boolean | null } | null };

export type IsLoggedInQueryVariables = Exact<{
  userName: Scalars["String"];
}>;

export type IsLoggedInQuery = { __typename?: "RootQueryType"; isLoggedIn?: string | null };

export type ReVerifyEmailQueryVariables = Exact<{
  debug?: InputMaybe<Scalars["String"]>;
}>;

export type ReVerifyEmailQuery = {
  __typename?: "RootQueryType";
  reverifyEmail?: { __typename?: "Status"; success?: boolean | null } | null;
};

export type BillingDataQueryVariables = Exact<{ [key: string]: never }>;

export type BillingDataQuery = {
  __typename?: "RootQueryType";
  getBillingData?: {
    __typename?: "BillingData";
    invoices?: Array<{
      __typename?: "Invoice";
      currency?: string | null;
      paid?: boolean | null;
      brand?: string | null;
      last4?: string | null;
      periodStart?: any | null;
      periodEnd?: any | null;
      totalPaid?: number | null;
    } | null> | null;
    subscription?: {
      __typename?: "PaymentSubscription";
      cancelAtPeriodEnd?: boolean | null;
      currentPeriodEnd?: any | null;
      status?: string | null;
      isBraintree?: boolean | null;
    } | null;
    upcomingInvoice?: {
      __typename?: "UpcomingInvoice";
      chargeAmount?: number | null;
      subtotal?: number | null;
      error?: string | null;
      nextPaymentAttempt?: number | null;
    } | null;
  } | null;
};

export type ForgotPasswordQueryVariables = Exact<{
  email: Scalars["String"];
  debug?: InputMaybe<Scalars["String"]>;
}>;

export type ForgotPasswordQuery = {
  __typename?: "RootQueryType";
  forgotPassword?: { __typename?: "Status"; success?: boolean | null } | null;
};

export type GetOauthConnectionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetOauthConnectionsQuery = {
  __typename?: "RootQueryType";
  getOauthConnections?: Array<{
    __typename?: "OauthConnection";
    connectionUuid: string;
    lastRefreshTime?: any | null;
    metadata?: { [key: string]: any } | null;
    providerName: string;
    providerUserId: string;
    providerUsername?: string | null;
    providerEmail?: string | null;
    creationTime?: any | null;
  } | null> | null;
};

export type InitiateOauthLoginQueryVariables = Exact<{
  providerName: Scalars["String"];
  mode?: InputMaybe<Scalars["String"]>;
  redirectLocal?: InputMaybe<Scalars["Boolean"]>;
}>;

export type InitiateOauthLoginQuery = {
  __typename?: "RootQueryType";
  initiateOauthLogin?: { __typename?: "OauthLoginUrl"; url: string } | null;
};

export type InitiateOauthLinkQueryVariables = Exact<{
  providerName: Scalars["String"];
  redirectLocal?: InputMaybe<Scalars["Boolean"]>;
}>;

export type InitiateOauthLinkQuery = {
  __typename?: "RootQueryType";
  initiateOauthLink?: { __typename?: "OauthLoginUrl"; url: string } | null;
};

export type CompleteOauthLoginMutationVariables = Exact<{
  oauthCallbackToken: Scalars["String"];
  providerName: Scalars["String"];
}>;

export type CompleteOauthLoginMutation = {
  __typename?: "RootMutationType";
  completeOauthLogin?: {
    __typename?: "OauthLoginResult";
    oauthSessionToken?: string | null;
    providerEmail?: string | null;
    providerUsername?: string | null;
    state?: {
      __typename?: "State";
      firstName: string;
      lastName: string;
      email: string;
      isVerified: boolean;
      googleAnalyticsId?: string | null;
      loginState?: { __typename?: "LoginState"; token: string } | null;
      lolSettings: {
        __typename?: "LolSettings";
        summoners?: Array<{
          __typename?: "Summoner";
          isDefault?: boolean | null;
          regionId: string;
          riotUserName: string;
          riotTagLine: string;
          verified?: boolean | null;
          iconUrl?: string | null;
          iconId?: string | null;
        } | null> | null;
        favoriteChampions?: Array<{ __typename?: "Champion"; championId: number } | null> | null;
        favoriteSummoners?: Array<{
          __typename?: "Summoner";
          regionId: string;
          riotUserName: string;
          riotTagLine: string;
          iconUrl?: string | null;
          iconId?: string | null;
        } | null> | null;
      };
      filterDefaults?: {
        __typename?: "FilterDefaults";
        filterTierList?: {
          __typename?: "FilterTierList";
          mmr?: string | null;
          queueType?: string | null;
          regionId?: string | null;
          role?: string | null;
          showAllChampions?: boolean | null;
        } | null;
        filterBuildsAndRunes?: {
          __typename?: "FilterBuildsAndRunes";
          mmr?: string | null;
          queueType?: string | null;
          regionId?: string | null;
        } | null;
      } | null;
      oauthConnections?: Array<{
        __typename?: "OauthConnection";
        connectionUuid: string;
        lastRefreshTime?: any | null;
        metadata?: { [key: string]: any } | null;
        providerName: string;
        providerUserId: string;
        providerUsername?: string | null;
        providerEmail?: string | null;
        creationTime?: any | null;
      } | null> | null;
      premium: {
        __typename?: "Premium";
        isPremium: boolean;
        premiumVersion?: string | null;
        hasFailedPayment?: boolean | null;
        paymentFailureDate?: any | null;
      };
    } | null;
  } | null;
};

export type CompleteOauthLinkMutationVariables = Exact<{
  oauthCallbackToken: Scalars["String"];
  providerName: Scalars["String"];
}>;

export type CompleteOauthLinkMutation = {
  __typename?: "RootMutationType";
  completeOauthLink?: {
    __typename?: "OauthConnection";
    connectionUuid: string;
    lastRefreshTime?: any | null;
    providerName: string;
    providerUserId: string;
    providerUsername?: string | null;
    providerEmail?: string | null;
    creationTime?: any | null;
  } | null;
};

export type CreateAccountWithOauthMutationVariables = Exact<{
  agreementSigned: Scalars["Boolean"];
  email: Scalars["String"];
  marketingOptOut: Scalars["Boolean"];
  oauthSessionToken: Scalars["String"];
  password: Scalars["String"];
}>;

export type CreateAccountWithOauthMutation = {
  __typename?: "RootMutationType";
  createAccountWithOauth?: {
    __typename?: "State";
    firstName: string;
    lastName: string;
    email: string;
    isVerified: boolean;
    googleAnalyticsId?: string | null;
    loginState?: { __typename?: "LoginState"; token: string } | null;
    lolSettings: {
      __typename?: "LolSettings";
      summoners?: Array<{
        __typename?: "Summoner";
        isDefault?: boolean | null;
        regionId: string;
        riotUserName: string;
        riotTagLine: string;
        verified?: boolean | null;
        iconUrl?: string | null;
        iconId?: string | null;
      } | null> | null;
      favoriteChampions?: Array<{ __typename?: "Champion"; championId: number } | null> | null;
      favoriteSummoners?: Array<{
        __typename?: "Summoner";
        regionId: string;
        riotUserName: string;
        riotTagLine: string;
        iconUrl?: string | null;
        iconId?: string | null;
      } | null> | null;
    };
    filterDefaults?: {
      __typename?: "FilterDefaults";
      filterTierList?: {
        __typename?: "FilterTierList";
        mmr?: string | null;
        queueType?: string | null;
        regionId?: string | null;
        role?: string | null;
        showAllChampions?: boolean | null;
      } | null;
      filterBuildsAndRunes?: {
        __typename?: "FilterBuildsAndRunes";
        mmr?: string | null;
        queueType?: string | null;
        regionId?: string | null;
      } | null;
    } | null;
    oauthConnections?: Array<{
      __typename?: "OauthConnection";
      connectionUuid: string;
      lastRefreshTime?: any | null;
      metadata?: { [key: string]: any } | null;
      providerName: string;
      providerUserId: string;
      providerUsername?: string | null;
      providerEmail?: string | null;
      creationTime?: any | null;
    } | null> | null;
    premium: {
      __typename?: "Premium";
      isPremium: boolean;
      premiumVersion?: string | null;
      hasFailedPayment?: boolean | null;
      paymentFailureDate?: any | null;
    };
  } | null;
};

export type LinkOauthToExistingAccountMutationVariables = Exact<{
  email: Scalars["String"];
  oauthSessionToken: Scalars["String"];
  password: Scalars["String"];
}>;

export type LinkOauthToExistingAccountMutation = {
  __typename?: "RootMutationType";
  linkOauthToExistingAccount?: {
    __typename?: "State";
    firstName: string;
    lastName: string;
    email: string;
    isVerified: boolean;
    googleAnalyticsId?: string | null;
    loginState?: { __typename?: "LoginState"; token: string } | null;
    lolSettings: {
      __typename?: "LolSettings";
      summoners?: Array<{
        __typename?: "Summoner";
        isDefault?: boolean | null;
        regionId: string;
        riotUserName: string;
        riotTagLine: string;
        verified?: boolean | null;
        iconUrl?: string | null;
        iconId?: string | null;
      } | null> | null;
      favoriteChampions?: Array<{ __typename?: "Champion"; championId: number } | null> | null;
      favoriteSummoners?: Array<{
        __typename?: "Summoner";
        regionId: string;
        riotUserName: string;
        riotTagLine: string;
        iconUrl?: string | null;
        iconId?: string | null;
      } | null> | null;
    };
    filterDefaults?: {
      __typename?: "FilterDefaults";
      filterTierList?: {
        __typename?: "FilterTierList";
        mmr?: string | null;
        queueType?: string | null;
        regionId?: string | null;
        role?: string | null;
        showAllChampions?: boolean | null;
      } | null;
      filterBuildsAndRunes?: {
        __typename?: "FilterBuildsAndRunes";
        mmr?: string | null;
        queueType?: string | null;
        regionId?: string | null;
      } | null;
    } | null;
    oauthConnections?: Array<{
      __typename?: "OauthConnection";
      connectionUuid: string;
      lastRefreshTime?: any | null;
      metadata?: { [key: string]: any } | null;
      providerName: string;
      providerUserId: string;
      providerUsername?: string | null;
      providerEmail?: string | null;
      creationTime?: any | null;
    } | null> | null;
    premium: {
      __typename?: "Premium";
      isPremium: boolean;
      premiumVersion?: string | null;
      hasFailedPayment?: boolean | null;
      paymentFailureDate?: any | null;
    };
  } | null;
};

export type RegisterMutationVariables = Exact<{
  email: Scalars["String"];
  password: Scalars["String"];
  marketingOptOut: Scalars["Boolean"];
  agreementSigned: Scalars["Boolean"];
  primarySummoner?: InputMaybe<InputSummoner>;
}>;

export type RegisterMutation = {
  __typename?: "RootMutationType";
  register?: { __typename?: "LoginState"; token: string } | null;
};

export type UpdatePasswordMutationVariables = Exact<{
  newPassword: Scalars["String"];
  password?: InputMaybe<Scalars["String"]>;
  passwordResetHash?: InputMaybe<Scalars["String"]>;
}>;

export type UpdatePasswordMutation = {
  __typename?: "RootMutationType";
  updatePassword?: { __typename?: "Status"; success?: boolean | null } | null;
};

export type VerifyEmailMutationVariables = Exact<{
  verificationCode: Scalars["String"];
}>;

export type VerifyEmailMutation = {
  __typename?: "RootMutationType";
  verify?: { __typename?: "Status"; success?: boolean | null } | null;
};

export type UpdateEmailMutationVariables = Exact<{
  oldEmail: Scalars["String"];
  newEmail: Scalars["String"];
  password: Scalars["String"];
}>;

export type UpdateEmailMutation = {
  __typename?: "RootMutationType";
  updateEmail?: { __typename?: "LoginState"; token: string } | null;
};

export type DeleteAccountMutationVariables = Exact<{
  email: Scalars["String"];
  password: Scalars["String"];
}>;

export type DeleteAccountMutation = {
  __typename?: "RootMutationType";
  deleteUser?: { __typename?: "Status"; success?: boolean | null } | null;
};

export type UnlinkOauthConnectionMutationVariables = Exact<{
  connectionUuid: Scalars["String"];
}>;

export type UnlinkOauthConnectionMutation = {
  __typename?: "RootMutationType";
  unlinkOauthConnection?: { __typename?: "Status"; success?: boolean | null } | null;
};

export type GetSocialLinksQueryVariables = Exact<{ [key: string]: never }>;

export type GetSocialLinksQuery = {
  __typename?: "RootQueryType";
  getSocialLinks?: Array<{
    __typename?: "SocialLink";
    socialLinkUuid: string;
    platform: string;
    username: string;
    url: string;
    creationTime?: any | null;
    updatedTime?: any | null;
  } | null> | null;
};

export type UpdateSocialLinkMutationVariables = Exact<{
  platform: Scalars["String"];
  username: Scalars["String"];
}>;

export type UpdateSocialLinkMutation = {
  __typename?: "RootMutationType";
  updateSocialLink?: {
    __typename?: "SocialLink";
    socialLinkUuid: string;
    platform: string;
    username: string;
    url: string;
    creationTime?: any | null;
    updatedTime?: any | null;
  } | null;
};

export type DeleteSocialLinkMutationVariables = Exact<{
  platform: Scalars["String"];
}>;

export type DeleteSocialLinkMutation = {
  __typename?: "RootMutationType";
  deleteSocialLink?: { __typename?: "Status"; success?: boolean | null } | null;
};

export const FragLoginStateFragmentDoc = gql`
  fragment fragLoginState on State {
    firstName
    lastName
    email
    isVerified
    googleAnalyticsId
    loginState {
      token
    }
    lolSettings {
      summoners {
        isDefault
        regionId
        riotUserName
        riotTagLine
        verified
        iconUrl
        iconId
      }
      favoriteChampions {
        championId
      }
      favoriteSummoners {
        regionId
        riotUserName
        riotTagLine
        iconUrl
        iconId
      }
    }
    filterDefaults {
      filterTierList {
        mmr
        queueType
        regionId
        role
        showAllChampions
      }
      filterBuildsAndRunes {
        mmr
        queueType
        regionId
      }
    }
    oauthConnections {
      connectionUuid
      lastRefreshTime
      metadata
      providerName
      providerUserId
      providerUsername
      providerEmail
      creationTime
    }
    premium {
      isPremium
      premiumVersion
      hasFailedPayment
      paymentFailureDate
    }
  }
`;
export const LoginDocument = gql`
  query login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      ...fragLoginState
    }
  }
  ${FragLoginStateFragmentDoc}
`;

/**
 * __useLoginQuery__
 *
 * To run a query within a React component, call `useLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginQuery({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginQuery(baseOptions: Apollo.QueryHookOptions<LoginQuery, LoginQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
}
export function useLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginQuery, LoginQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
}
export type LoginQueryHookResult = ReturnType<typeof useLoginQuery>;
export type LoginLazyQueryHookResult = ReturnType<typeof useLoginLazyQuery>;
export type LoginQueryResult = Apollo.QueryResult<LoginQuery, LoginQueryVariables>;
export const LogoutDocument = gql`
  query logout {
    logout {
      success
    }
  }
`;

/**
 * __useLogoutQuery__
 *
 * To run a query within a React component, call `useLogoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useLogoutQuery(baseOptions?: Apollo.QueryHookOptions<LogoutQuery, LogoutQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LogoutQuery, LogoutQueryVariables>(LogoutDocument, options);
}
export function useLogoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogoutQuery, LogoutQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LogoutQuery, LogoutQueryVariables>(LogoutDocument, options);
}
export type LogoutQueryHookResult = ReturnType<typeof useLogoutQuery>;
export type LogoutLazyQueryHookResult = ReturnType<typeof useLogoutLazyQuery>;
export type LogoutQueryResult = Apollo.QueryResult<LogoutQuery, LogoutQueryVariables>;
export const IsLoggedInDocument = gql`
  query isLoggedIn($userName: String!) {
    isLoggedIn(userName: $userName)
  }
`;

/**
 * __useIsLoggedInQuery__
 *
 * To run a query within a React component, call `useIsLoggedInQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsLoggedInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsLoggedInQuery({
 *   variables: {
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useIsLoggedInQuery(baseOptions: Apollo.QueryHookOptions<IsLoggedInQuery, IsLoggedInQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IsLoggedInQuery, IsLoggedInQueryVariables>(IsLoggedInDocument, options);
}
export function useIsLoggedInLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsLoggedInQuery, IsLoggedInQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IsLoggedInQuery, IsLoggedInQueryVariables>(IsLoggedInDocument, options);
}
export type IsLoggedInQueryHookResult = ReturnType<typeof useIsLoggedInQuery>;
export type IsLoggedInLazyQueryHookResult = ReturnType<typeof useIsLoggedInLazyQuery>;
export type IsLoggedInQueryResult = Apollo.QueryResult<IsLoggedInQuery, IsLoggedInQueryVariables>;
export const ReVerifyEmailDocument = gql`
  query reVerifyEmail($debug: String) {
    reverifyEmail(debug: $debug) {
      success
    }
  }
`;

/**
 * __useReVerifyEmailQuery__
 *
 * To run a query within a React component, call `useReVerifyEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useReVerifyEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReVerifyEmailQuery({
 *   variables: {
 *      debug: // value for 'debug'
 *   },
 * });
 */
export function useReVerifyEmailQuery(baseOptions?: Apollo.QueryHookOptions<ReVerifyEmailQuery, ReVerifyEmailQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReVerifyEmailQuery, ReVerifyEmailQueryVariables>(ReVerifyEmailDocument, options);
}
export function useReVerifyEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReVerifyEmailQuery, ReVerifyEmailQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReVerifyEmailQuery, ReVerifyEmailQueryVariables>(ReVerifyEmailDocument, options);
}
export type ReVerifyEmailQueryHookResult = ReturnType<typeof useReVerifyEmailQuery>;
export type ReVerifyEmailLazyQueryHookResult = ReturnType<typeof useReVerifyEmailLazyQuery>;
export type ReVerifyEmailQueryResult = Apollo.QueryResult<ReVerifyEmailQuery, ReVerifyEmailQueryVariables>;
export const BillingDataDocument = gql`
  query billingData {
    getBillingData {
      invoices {
        currency
        paid
        brand
        last4
        periodStart
        periodEnd
        totalPaid
      }
      subscription {
        cancelAtPeriodEnd
        currentPeriodEnd
        status
        isBraintree
      }
      upcomingInvoice {
        chargeAmount
        subtotal
        error
        nextPaymentAttempt
      }
    }
  }
`;

/**
 * __useBillingDataQuery__
 *
 * To run a query within a React component, call `useBillingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useBillingDataQuery(baseOptions?: Apollo.QueryHookOptions<BillingDataQuery, BillingDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BillingDataQuery, BillingDataQueryVariables>(BillingDataDocument, options);
}
export function useBillingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingDataQuery, BillingDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BillingDataQuery, BillingDataQueryVariables>(BillingDataDocument, options);
}
export type BillingDataQueryHookResult = ReturnType<typeof useBillingDataQuery>;
export type BillingDataLazyQueryHookResult = ReturnType<typeof useBillingDataLazyQuery>;
export type BillingDataQueryResult = Apollo.QueryResult<BillingDataQuery, BillingDataQueryVariables>;
export const ForgotPasswordDocument = gql`
  query forgotPassword($email: String!, $debug: String) {
    forgotPassword(email: $email, debug: $debug) {
      success
    }
  }
`;

/**
 * __useForgotPasswordQuery__
 *
 * To run a query within a React component, call `useForgotPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useForgotPasswordQuery({
 *   variables: {
 *      email: // value for 'email'
 *      debug: // value for 'debug'
 *   },
 * });
 */
export function useForgotPasswordQuery(baseOptions: Apollo.QueryHookOptions<ForgotPasswordQuery, ForgotPasswordQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ForgotPasswordQuery, ForgotPasswordQueryVariables>(ForgotPasswordDocument, options);
}
export function useForgotPasswordLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ForgotPasswordQuery, ForgotPasswordQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ForgotPasswordQuery, ForgotPasswordQueryVariables>(ForgotPasswordDocument, options);
}
export type ForgotPasswordQueryHookResult = ReturnType<typeof useForgotPasswordQuery>;
export type ForgotPasswordLazyQueryHookResult = ReturnType<typeof useForgotPasswordLazyQuery>;
export type ForgotPasswordQueryResult = Apollo.QueryResult<ForgotPasswordQuery, ForgotPasswordQueryVariables>;
export const GetOauthConnectionsDocument = gql`
  query getOauthConnections {
    getOauthConnections {
      connectionUuid
      lastRefreshTime
      metadata
      providerName
      providerUserId
      providerUsername
      providerEmail
      creationTime
    }
  }
`;

/**
 * __useGetOauthConnectionsQuery__
 *
 * To run a query within a React component, call `useGetOauthConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOauthConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOauthConnectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOauthConnectionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetOauthConnectionsQuery, GetOauthConnectionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOauthConnectionsQuery, GetOauthConnectionsQueryVariables>(GetOauthConnectionsDocument, options);
}
export function useGetOauthConnectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOauthConnectionsQuery, GetOauthConnectionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOauthConnectionsQuery, GetOauthConnectionsQueryVariables>(GetOauthConnectionsDocument, options);
}
export type GetOauthConnectionsQueryHookResult = ReturnType<typeof useGetOauthConnectionsQuery>;
export type GetOauthConnectionsLazyQueryHookResult = ReturnType<typeof useGetOauthConnectionsLazyQuery>;
export type GetOauthConnectionsQueryResult = Apollo.QueryResult<GetOauthConnectionsQuery, GetOauthConnectionsQueryVariables>;
export const InitiateOauthLoginDocument = gql`
  query initiateOauthLogin($providerName: String!, $mode: String, $redirectLocal: Boolean) {
    initiateOauthLogin(providerName: $providerName, mode: $mode, redirectLocal: $redirectLocal) {
      url
    }
  }
`;

/**
 * __useInitiateOauthLoginQuery__
 *
 * To run a query within a React component, call `useInitiateOauthLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiateOauthLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiateOauthLoginQuery({
 *   variables: {
 *      providerName: // value for 'providerName'
 *      mode: // value for 'mode'
 *      redirectLocal: // value for 'redirectLocal'
 *   },
 * });
 */
export function useInitiateOauthLoginQuery(
  baseOptions: Apollo.QueryHookOptions<InitiateOauthLoginQuery, InitiateOauthLoginQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InitiateOauthLoginQuery, InitiateOauthLoginQueryVariables>(InitiateOauthLoginDocument, options);
}
export function useInitiateOauthLoginLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InitiateOauthLoginQuery, InitiateOauthLoginQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InitiateOauthLoginQuery, InitiateOauthLoginQueryVariables>(InitiateOauthLoginDocument, options);
}
export type InitiateOauthLoginQueryHookResult = ReturnType<typeof useInitiateOauthLoginQuery>;
export type InitiateOauthLoginLazyQueryHookResult = ReturnType<typeof useInitiateOauthLoginLazyQuery>;
export type InitiateOauthLoginQueryResult = Apollo.QueryResult<InitiateOauthLoginQuery, InitiateOauthLoginQueryVariables>;
export const InitiateOauthLinkDocument = gql`
  query initiateOauthLink($providerName: String!, $redirectLocal: Boolean) {
    initiateOauthLink(providerName: $providerName, redirectLocal: $redirectLocal) {
      url
    }
  }
`;

/**
 * __useInitiateOauthLinkQuery__
 *
 * To run a query within a React component, call `useInitiateOauthLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiateOauthLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiateOauthLinkQuery({
 *   variables: {
 *      providerName: // value for 'providerName'
 *      redirectLocal: // value for 'redirectLocal'
 *   },
 * });
 */
export function useInitiateOauthLinkQuery(
  baseOptions: Apollo.QueryHookOptions<InitiateOauthLinkQuery, InitiateOauthLinkQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InitiateOauthLinkQuery, InitiateOauthLinkQueryVariables>(InitiateOauthLinkDocument, options);
}
export function useInitiateOauthLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InitiateOauthLinkQuery, InitiateOauthLinkQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InitiateOauthLinkQuery, InitiateOauthLinkQueryVariables>(InitiateOauthLinkDocument, options);
}
export type InitiateOauthLinkQueryHookResult = ReturnType<typeof useInitiateOauthLinkQuery>;
export type InitiateOauthLinkLazyQueryHookResult = ReturnType<typeof useInitiateOauthLinkLazyQuery>;
export type InitiateOauthLinkQueryResult = Apollo.QueryResult<InitiateOauthLinkQuery, InitiateOauthLinkQueryVariables>;
export const CompleteOauthLoginDocument = gql`
  mutation completeOauthLogin($oauthCallbackToken: String!, $providerName: String!) {
    completeOauthLogin(oauthCallbackToken: $oauthCallbackToken, providerName: $providerName) {
      oauthSessionToken
      providerEmail
      providerUsername
      state {
        ...fragLoginState
      }
    }
  }
  ${FragLoginStateFragmentDoc}
`;
export type CompleteOauthLoginMutationFn = Apollo.MutationFunction<
  CompleteOauthLoginMutation,
  CompleteOauthLoginMutationVariables
>;

/**
 * __useCompleteOauthLoginMutation__
 *
 * To run a mutation, you first call `useCompleteOauthLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOauthLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeOauthLoginMutation, { data, loading, error }] = useCompleteOauthLoginMutation({
 *   variables: {
 *      oauthCallbackToken: // value for 'oauthCallbackToken'
 *      providerName: // value for 'providerName'
 *   },
 * });
 */
export function useCompleteOauthLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<CompleteOauthLoginMutation, CompleteOauthLoginMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CompleteOauthLoginMutation, CompleteOauthLoginMutationVariables>(CompleteOauthLoginDocument, options);
}
export type CompleteOauthLoginMutationHookResult = ReturnType<typeof useCompleteOauthLoginMutation>;
export type CompleteOauthLoginMutationResult = Apollo.MutationResult<CompleteOauthLoginMutation>;
export type CompleteOauthLoginMutationOptions = Apollo.BaseMutationOptions<
  CompleteOauthLoginMutation,
  CompleteOauthLoginMutationVariables
>;
export const CompleteOauthLinkDocument = gql`
  mutation completeOauthLink($oauthCallbackToken: String!, $providerName: String!) {
    completeOauthLink(oauthCallbackToken: $oauthCallbackToken, providerName: $providerName) {
      connectionUuid
      lastRefreshTime
      providerName
      providerUserId
      providerUsername
      providerEmail
      creationTime
    }
  }
`;
export type CompleteOauthLinkMutationFn = Apollo.MutationFunction<CompleteOauthLinkMutation, CompleteOauthLinkMutationVariables>;

/**
 * __useCompleteOauthLinkMutation__
 *
 * To run a mutation, you first call `useCompleteOauthLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOauthLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeOauthLinkMutation, { data, loading, error }] = useCompleteOauthLinkMutation({
 *   variables: {
 *      oauthCallbackToken: // value for 'oauthCallbackToken'
 *      providerName: // value for 'providerName'
 *   },
 * });
 */
export function useCompleteOauthLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<CompleteOauthLinkMutation, CompleteOauthLinkMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CompleteOauthLinkMutation, CompleteOauthLinkMutationVariables>(CompleteOauthLinkDocument, options);
}
export type CompleteOauthLinkMutationHookResult = ReturnType<typeof useCompleteOauthLinkMutation>;
export type CompleteOauthLinkMutationResult = Apollo.MutationResult<CompleteOauthLinkMutation>;
export type CompleteOauthLinkMutationOptions = Apollo.BaseMutationOptions<
  CompleteOauthLinkMutation,
  CompleteOauthLinkMutationVariables
>;
export const CreateAccountWithOauthDocument = gql`
  mutation createAccountWithOauth(
    $agreementSigned: Boolean!
    $email: String!
    $marketingOptOut: Boolean!
    $oauthSessionToken: String!
    $password: String!
  ) {
    createAccountWithOauth(
      agreementSigned: $agreementSigned
      email: $email
      marketingOptOut: $marketingOptOut
      oauthSessionToken: $oauthSessionToken
      password: $password
    ) {
      ...fragLoginState
    }
  }
  ${FragLoginStateFragmentDoc}
`;
export type CreateAccountWithOauthMutationFn = Apollo.MutationFunction<
  CreateAccountWithOauthMutation,
  CreateAccountWithOauthMutationVariables
>;

/**
 * __useCreateAccountWithOauthMutation__
 *
 * To run a mutation, you first call `useCreateAccountWithOauthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountWithOauthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountWithOauthMutation, { data, loading, error }] = useCreateAccountWithOauthMutation({
 *   variables: {
 *      agreementSigned: // value for 'agreementSigned'
 *      email: // value for 'email'
 *      marketingOptOut: // value for 'marketingOptOut'
 *      oauthSessionToken: // value for 'oauthSessionToken'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCreateAccountWithOauthMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAccountWithOauthMutation, CreateAccountWithOauthMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAccountWithOauthMutation, CreateAccountWithOauthMutationVariables>(
    CreateAccountWithOauthDocument,
    options,
  );
}
export type CreateAccountWithOauthMutationHookResult = ReturnType<typeof useCreateAccountWithOauthMutation>;
export type CreateAccountWithOauthMutationResult = Apollo.MutationResult<CreateAccountWithOauthMutation>;
export type CreateAccountWithOauthMutationOptions = Apollo.BaseMutationOptions<
  CreateAccountWithOauthMutation,
  CreateAccountWithOauthMutationVariables
>;
export const LinkOauthToExistingAccountDocument = gql`
  mutation linkOauthToExistingAccount($email: String!, $oauthSessionToken: String!, $password: String!) {
    linkOauthToExistingAccount(email: $email, oauthSessionToken: $oauthSessionToken, password: $password) {
      ...fragLoginState
    }
  }
  ${FragLoginStateFragmentDoc}
`;
export type LinkOauthToExistingAccountMutationFn = Apollo.MutationFunction<
  LinkOauthToExistingAccountMutation,
  LinkOauthToExistingAccountMutationVariables
>;

/**
 * __useLinkOauthToExistingAccountMutation__
 *
 * To run a mutation, you first call `useLinkOauthToExistingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkOauthToExistingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkOauthToExistingAccountMutation, { data, loading, error }] = useLinkOauthToExistingAccountMutation({
 *   variables: {
 *      email: // value for 'email'
 *      oauthSessionToken: // value for 'oauthSessionToken'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLinkOauthToExistingAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<LinkOauthToExistingAccountMutation, LinkOauthToExistingAccountMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LinkOauthToExistingAccountMutation, LinkOauthToExistingAccountMutationVariables>(
    LinkOauthToExistingAccountDocument,
    options,
  );
}
export type LinkOauthToExistingAccountMutationHookResult = ReturnType<typeof useLinkOauthToExistingAccountMutation>;
export type LinkOauthToExistingAccountMutationResult = Apollo.MutationResult<LinkOauthToExistingAccountMutation>;
export type LinkOauthToExistingAccountMutationOptions = Apollo.BaseMutationOptions<
  LinkOauthToExistingAccountMutation,
  LinkOauthToExistingAccountMutationVariables
>;
export const RegisterDocument = gql`
  mutation register(
    $email: String!
    $password: String!
    $marketingOptOut: Boolean!
    $agreementSigned: Boolean!
    $primarySummoner: InputSummoner
  ) {
    register(
      email: $email
      password: $password
      marketingOptOut: $marketingOptOut
      agreementSigned: $agreementSigned
      primarySummoner: $primarySummoner
    ) {
      token
    }
  }
`;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      marketingOptOut: // value for 'marketingOptOut'
 *      agreementSigned: // value for 'agreementSigned'
 *      primarySummoner: // value for 'primarySummoner'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
}
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const UpdatePasswordDocument = gql`
  mutation updatePassword($newPassword: String!, $password: String, $passwordResetHash: String) {
    updatePassword(newPassword: $newPassword, password: $password, passwordResetHash: $passwordResetHash) {
      success
    }
  }
`;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      password: // value for 'password'
 *      passwordResetHash: // value for 'passwordResetHash'
 *   },
 * });
 */
export function useUpdatePasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
}
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const VerifyEmailDocument = gql`
  mutation verifyEmail($verificationCode: String!) {
    verify(verificationCode: $verificationCode) {
      success
    }
  }
`;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      verificationCode: // value for 'verificationCode'
 *   },
 * });
 */
export function useVerifyEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
}
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const UpdateEmailDocument = gql`
  mutation updateEmail($oldEmail: String!, $newEmail: String!, $password: String!) {
    updateEmail(oldEmail: $oldEmail, newEmail: $newEmail, password: $password) {
      token
    }
  }
`;
export type UpdateEmailMutationFn = Apollo.MutationFunction<UpdateEmailMutation, UpdateEmailMutationVariables>;

/**
 * __useUpdateEmailMutation__
 *
 * To run a mutation, you first call `useUpdateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailMutation, { data, loading, error }] = useUpdateEmailMutation({
 *   variables: {
 *      oldEmail: // value for 'oldEmail'
 *      newEmail: // value for 'newEmail'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useUpdateEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateEmailMutation, UpdateEmailMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateEmailMutation, UpdateEmailMutationVariables>(UpdateEmailDocument, options);
}
export type UpdateEmailMutationHookResult = ReturnType<typeof useUpdateEmailMutation>;
export type UpdateEmailMutationResult = Apollo.MutationResult<UpdateEmailMutation>;
export type UpdateEmailMutationOptions = Apollo.BaseMutationOptions<UpdateEmailMutation, UpdateEmailMutationVariables>;
export const DeleteAccountDocument = gql`
  mutation deleteAccount($email: String!, $password: String!) {
    deleteUser(email: $email, password: $password) {
      success
    }
  }
`;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useDeleteAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
}
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const UnlinkOauthConnectionDocument = gql`
  mutation unlinkOauthConnection($connectionUuid: String!) {
    unlinkOauthConnection(connectionUuid: $connectionUuid) {
      success
    }
  }
`;
export type UnlinkOauthConnectionMutationFn = Apollo.MutationFunction<
  UnlinkOauthConnectionMutation,
  UnlinkOauthConnectionMutationVariables
>;

/**
 * __useUnlinkOauthConnectionMutation__
 *
 * To run a mutation, you first call `useUnlinkOauthConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkOauthConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkOauthConnectionMutation, { data, loading, error }] = useUnlinkOauthConnectionMutation({
 *   variables: {
 *      connectionUuid: // value for 'connectionUuid'
 *   },
 * });
 */
export function useUnlinkOauthConnectionMutation(
  baseOptions?: Apollo.MutationHookOptions<UnlinkOauthConnectionMutation, UnlinkOauthConnectionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnlinkOauthConnectionMutation, UnlinkOauthConnectionMutationVariables>(
    UnlinkOauthConnectionDocument,
    options,
  );
}
export type UnlinkOauthConnectionMutationHookResult = ReturnType<typeof useUnlinkOauthConnectionMutation>;
export type UnlinkOauthConnectionMutationResult = Apollo.MutationResult<UnlinkOauthConnectionMutation>;
export type UnlinkOauthConnectionMutationOptions = Apollo.BaseMutationOptions<
  UnlinkOauthConnectionMutation,
  UnlinkOauthConnectionMutationVariables
>;
export const GetSocialLinksDocument = gql`
  query getSocialLinks {
    getSocialLinks {
      socialLinkUuid
      platform
      username
      url
      creationTime
      updatedTime
    }
  }
`;

/**
 * __useGetSocialLinksQuery__
 *
 * To run a query within a React component, call `useGetSocialLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialLinksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSocialLinksQuery(baseOptions?: Apollo.QueryHookOptions<GetSocialLinksQuery, GetSocialLinksQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSocialLinksQuery, GetSocialLinksQueryVariables>(GetSocialLinksDocument, options);
}
export function useGetSocialLinksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSocialLinksQuery, GetSocialLinksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSocialLinksQuery, GetSocialLinksQueryVariables>(GetSocialLinksDocument, options);
}
export type GetSocialLinksQueryHookResult = ReturnType<typeof useGetSocialLinksQuery>;
export type GetSocialLinksLazyQueryHookResult = ReturnType<typeof useGetSocialLinksLazyQuery>;
export type GetSocialLinksQueryResult = Apollo.QueryResult<GetSocialLinksQuery, GetSocialLinksQueryVariables>;
export const UpdateSocialLinkDocument = gql`
  mutation updateSocialLink($platform: String!, $username: String!) {
    updateSocialLink(platform: $platform, username: $username) {
      socialLinkUuid
      platform
      username
      url
      creationTime
      updatedTime
    }
  }
`;
export type UpdateSocialLinkMutationFn = Apollo.MutationFunction<UpdateSocialLinkMutation, UpdateSocialLinkMutationVariables>;

/**
 * __useUpdateSocialLinkMutation__
 *
 * To run a mutation, you first call `useUpdateSocialLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocialLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocialLinkMutation, { data, loading, error }] = useUpdateSocialLinkMutation({
 *   variables: {
 *      platform: // value for 'platform'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useUpdateSocialLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateSocialLinkMutation, UpdateSocialLinkMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateSocialLinkMutation, UpdateSocialLinkMutationVariables>(UpdateSocialLinkDocument, options);
}
export type UpdateSocialLinkMutationHookResult = ReturnType<typeof useUpdateSocialLinkMutation>;
export type UpdateSocialLinkMutationResult = Apollo.MutationResult<UpdateSocialLinkMutation>;
export type UpdateSocialLinkMutationOptions = Apollo.BaseMutationOptions<
  UpdateSocialLinkMutation,
  UpdateSocialLinkMutationVariables
>;
export const DeleteSocialLinkDocument = gql`
  mutation deleteSocialLink($platform: String!) {
    deleteSocialLink(platform: $platform) {
      success
    }
  }
`;
export type DeleteSocialLinkMutationFn = Apollo.MutationFunction<DeleteSocialLinkMutation, DeleteSocialLinkMutationVariables>;

/**
 * __useDeleteSocialLinkMutation__
 *
 * To run a mutation, you first call `useDeleteSocialLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSocialLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSocialLinkMutation, { data, loading, error }] = useDeleteSocialLinkMutation({
 *   variables: {
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useDeleteSocialLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteSocialLinkMutation, DeleteSocialLinkMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteSocialLinkMutation, DeleteSocialLinkMutationVariables>(DeleteSocialLinkDocument, options);
}
export type DeleteSocialLinkMutationHookResult = ReturnType<typeof useDeleteSocialLinkMutation>;
export type DeleteSocialLinkMutationResult = Apollo.MutationResult<DeleteSocialLinkMutation>;
export type DeleteSocialLinkMutationOptions = Apollo.BaseMutationOptions<
  DeleteSocialLinkMutation,
  DeleteSocialLinkMutationVariables
>;
